import React from 'react';

import { SVGProps } from './SVGProps';

const DashboardUserIcon = ({ fill = '#101828', width = '24', height = '25' }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 21.1367C20 19.7412 20 19.0434 19.8278 18.4756C19.44 17.1972 18.4395 16.1968 17.1611 15.809C16.5933 15.6367 15.8956 15.6367 14.5 15.6367H9.5C8.10444 15.6367 7.40665 15.6367 6.83886 15.809C5.56045 16.1968 4.56004 17.1972 4.17224 18.4756C4 19.0434 4 19.7412 4 21.1367M16.5 7.63672C16.5 10.122 14.4853 12.1367 12 12.1367C9.51472 12.1367 7.5 10.122 7.5 7.63672C7.5 5.15144 9.51472 3.13672 12 3.13672C14.4853 3.13672 16.5 5.15144 16.5 7.63672Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DashboardUserIcon;
